import { memo } from "react";

const LoadingSpinner = () => (
  <div className="spinner-border text-primary font-size-normal" role="status">
    <span className="visually-hidden">Loading...</span>
  </div>
);

// memo should prevent this from being rerendered if things are changing around it in the parent
export default memo(LoadingSpinner);
